export default __webpack_public_path__ + "static/media/senthilvel.116f4ac7.jpg";